module.exports = __webpack_public_path__ + "img/help-set-up-the-plant@3x.49005909.webp";